<!-- Wrapper Body -->
<div class="wrapper-body">
    <div class="page-header d-flex align-items-center">
      <h3>Follow Up</h3>
      <a href="javascript:void" class="theme-button grey ml-auto mr-3" onclick="filterButton()">Filter</a>
    </div>
    <div class="content">
      <form class="custom-form d-none" id="filterShow">
        <div class="row">
          <div class="col-md-6">
            <input type="text" id="filterSearch" placeholder="Type here to search"
              onkeyup="appointmentFilterFunction()">
          </div>
        </div>
      </form>
      <div class="card" *ngIf='(userRole=="ADMIN" || userRole=="DIRECTOR") && appointments.length>0'>
        <div class="table-responsive">
          <table class="custom-table filterTable" id="appointmentTable">
            <thead>
              <tr class="header">
                <th>Client Name</th>
                <th>Cell Number</th>
                <th>Email</th>
                <th>Assessment Type</th>
                <th> Date</th>
                <th> Time</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <!-- Loop -->
              <tr *ngFor="let appointment of appointments, index as i ">
                <td>{{appointment.parentDetails.studentFirstName}} {{appointment.parentDetails.studentLastName}}</td>
                <td>{{appointment.parentDetails.cellNumber}}</td>
                <td>{{appointment.parentDetails.emailAddress}}</td>
                <td class="">{{appointment.appointmentDetails.assesmentType}}</td>
                <td class="">{{followUpDetails[i].appointmentDate}}</td>
                <td class="">{{followUpDetails[i].appointmentTime}}</td>
                <td class="export-hide-column"><a [routerLink]="['/appt-all-details',appointment.appointmentDetails.appointmentId]">View Details</a></td>

              </tr>
  
            </tbody>
          </table>
        </div>
      </div>
     
      <div *ngIf="appointments.length<1">
         <div class="row">
          <div class="col-12">
            <div class="card py-5 px-2 text-center">
              <h4 class="text-grey">No Follow Up Appointments</h4>
              <!-- <p class="text-grey mb-0">Lorem ipsum dolor sit, amet consectetur adipisicing elit.</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  

  
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple">
    <!-- <p style="color: white">Please Wait... </p> -->
  </ngx-spinner>